import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import LoadingOverlay from 'src/components/common/LoadingOverlay';
import { RootState } from 'src/redux-store/appStore';
import { handleError } from 'src/redux-store/slices/errorSlice';
import { httpRequest } from 'src/services/httpRequest';
import CustomModal from '../customModal/CustomModal';

function DeleteApplication({ item, refetchListData }) {
  const [loading, setLoading] = useState(false);
  const [IsOpen, setIsOpen] = useState<boolean>(false);
  const [applicationIdToDelete, setApplicationIdToDelete] = useState();
  const dispatch = useDispatch();
  const currentPermitDetails = useSelector(
    (store: RootState) => store.currentPermit.currentPermitDetails
  );

  const handleDeleteApplication = async () => {
    setLoading(true);
    let url = `/applications/${currentPermitDetails.id}/delete?ApplicationID=${applicationIdToDelete}`;
    url =
      currentPermitDetails.id === 8
        ? `/clerk_vending/delete/${applicationIdToDelete}`
        : url;
    const response = await httpRequest('DELETE', url);
    if (response.status === 'success') {
      refetchListData();
      toast.success('Application deleted successfully.');
    } else {
      toast.error(response?.message);
      dispatch(handleError(response?.message));
    }
    setLoading(false);
  };

  return (
    <div>
      {loading && <LoadingOverlay />}

      <Tooltip title="Delete" arrow>
        <IconButton
          color="inherit"
          disabled={item?.ApplicationStatus !== 'In Review'}
          onClick={(e) => {
            e.preventDefault();
            setApplicationIdToDelete(item?.ApplicationID);
            setIsOpen(true);
          }}
          sx={{
            opacity: item?.ApplicationStatus !== 'In Review' ? 0.4 : 1,
            cursor: item?.ApplicationStatus !== 'In Review' ? 'not-allowed' : 'pointer'
          }}
        >
          <DeleteForeverIcon 
            color={item?.ApplicationStatus !== 'In Review' ? 'disabled' : 'error'} 
            fontSize="small" 
          />
        </IconButton>
      </Tooltip>
      <CustomModal
        title={'Delete Application?'}
        IsOpen={IsOpen}
        setIsOpen={setIsOpen}
        onSave={handleDeleteApplication}
        actionButtons={['No', 'Yes']}
        loading={loading}
        content={
          <Typography>
            Are you sure you want to delete this application?
          </Typography>
        }
      />
    </div>
  );
}

export default DeleteApplication;
